import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { environment } from '@env/environment';


type InkassoDecisionInfo = {
  isValid: boolean;
  isExpired?: boolean;
  message?: string;
  decisionType?: number;
  decisionLabel?: string;
  invoiceId?: number;
  invoiceNumber?: string;
};

type InkassoDecisionResult = {
  success: boolean;
  message?: string;
  decisionType?: number;
  invoiceId?: number;
};

@Component({
  selector: 'app-inkasso-decision',
  standalone: false,
  templateUrl: './inkasso-decision.component.html',
  styleUrls: ['./inkasso-decision.component.scss']
})
export class InkassoDecisionComponent implements OnInit, OnDestroy {
  loading = true;
  confirming = false;
  info: InkassoDecisionInfo | null = null;
  result: InkassoDecisionResult | null = null;
  token = '';
  logo = environment.logoUrl || 'assets/logo.png';

  private routeSub: Subscription;

  constructor(private route: ActivatedRoute, private http: HttpClient) {}

  ngOnInit(): void {
    this.routeSub = this.route.paramMap.subscribe(params => {
      const token = params.get('token');
      this.token = token || '';
      this.result = null;
      this.fetchInfo();
    });
  }

  ngOnDestroy(): void {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  confirm(): void {
    if (!this.token || this.confirming) {
      return;
    }

    this.confirming = true;
    const url = `${environment.hostBase}/public/inkasso/${this.token}/confirm-json`;
    const headers = new HttpHeaders({ Accept: 'application/json' });

    this.http.post<any>(url, {}, { headers })
      .subscribe({
        next: result => {
          this.result = {
            success: result?.success ?? result?.Success ?? false,
            message: result?.message ?? result?.Message,
            decisionType: result?.decisionType ?? result?.DecisionType,
            invoiceId: result?.invoiceId ?? result?.InvoiceId
          };
          this.confirming = false;
        },
        error: () => {
          this.result = { success: false, message: 'Något gick fel. Försök igen senare.' };
          this.confirming = false;
        }
      });
  }

  private fetchInfo(): void {
    if (!this.token) {
      this.info = { isValid: false, message: 'Länken är inte giltig.' };
      this.loading = false;
      return;
    }

    const url = `${environment.hostBase}/public/inkasso/${this.token}/info`;
    const headers = new HttpHeaders({ Accept: 'application/json' });

    this.loading = true;
    this.http.get<any>(url, { headers })
      .subscribe({
        next: info => {
          this.info = {
            isValid: info?.isValid ?? info?.IsValid ?? false,
            isExpired: info?.isExpired ?? info?.IsExpired,
            message: info?.message ?? info?.Message,
            decisionType: info?.decisionType ?? info?.DecisionType,
            decisionLabel: info?.decisionLabel ?? info?.DecisionLabel,
            invoiceId: info?.invoiceId ?? info?.InvoiceId,
            invoiceNumber: info?.invoiceNumber ?? info?.InvoiceNumber
          };
          this.loading = false;
        },
        error: () => {
          this.info = { isValid: false, message: 'Länken är inte giltig.' };
          this.loading = false;
        }
      });
  }
}
